import { Modal } from '@/components';

interface BackgroundModeModalProps {
	showBackgroundModeModal: boolean;
	onCloseBackgroundModeModal: () => void;
	setShowBackgroundModeModal: (show: boolean) => void;
}

export const BackgroundModeModal = ({ showBackgroundModeModal, setShowBackgroundModeModal, onCloseBackgroundModeModal }: BackgroundModeModalProps) => {
	return (
		<Modal
			isOpen={showBackgroundModeModal}
			onClose={() => setShowBackgroundModeModal(false)}
			size="sm"
			variant="centered"
			showCloseButton
			className="background-mode-modal">
			<div className="background-mode-modal-body">
				<div className="icon-container">
					<i className="icons-info-circle" />
				</div>
				<h2 className="modal-title">Arka Plan Modu Aktif</h2>
				<p className="modal-description">Arka plan modu aktif olduğunda uygulamada olmadığınız zamanlarda sistemde yeterli sayıda koç bulunmuyorsa tarafınıza öğrenci ataması gönderilir.</p>
				<button
					onClick={onCloseBackgroundModeModal}
					className="modal-button">
					Anladım
				</button>
			</div>
		</Modal>
	);
};
